export const SPEC_LABELS = {
	surface: "Superficie comercial",
	environments: "Ambientes",
	bathrooms: "Baños",
	rooms: "Dormitorios",
	toilets: "Toilettes",
	kitchens: "Cocinas",
};

export const SPEC_ORDER = [
  "surface",
  "environments",
  "rooms",
  "kitchens",
  "bathrooms",
  "toilets",
];
